module.exports = __webpack_public_path__ + "img/xingxing.23cc1f34.png";